import React, { useRef, useEffect, useState, ReactNode } from "react"
import Button from "components/Form/Button"
import { IoClose } from "react-icons/io5"
import { twMerge } from "tailwind-merge"

interface BottomSheetProps {
    isOpen: boolean
    onClose: () => void
    children?: ReactNode
    title?: string
    className?: string
    style?: any
}

const BottomSheetV2: React.FC<BottomSheetProps> = ({
    isOpen,
    onClose,
    children,
    title,
    className: customClassName,
    style
}) => {
    const sheetRef = useRef<HTMLDivElement>(null)
    const [isVisible, setIsVisible] = useState(isOpen)

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                sheetRef.current &&
                !sheetRef.current.contains(event.target as Node)
            ) {
                onClose()
            }
        }

        if (isVisible) {
            document.addEventListener("mousedown", handleClickOutside)
        } else {
            document.removeEventListener("mousedown", handleClickOutside)
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [isVisible, onClose])

    useEffect(() => {
        setIsVisible(isOpen)
    }, [isOpen])

    return (
        <div
            className={twMerge(
                `fixed bottom-0 right-0 w-full h-[50vh] w-screen z-40 transform rounded-t-3xl ${isVisible ? "translate-y-0" : "translate-y-full"
                } transition-transform duration-200 ease-out overflow-hidden  backdrop-blur-md `,
                customClassName
            )}
            style={{ ...style }}
            ref={sheetRef}
        >
            <div
                className="absolute inset-0 bg-opacity-30 rounded-t-3xl"
                onClick={onClose}
            ></div>
            <div className="content relative h-full w-full text-[#201750] bg-dark_white bg-opacity-80 shadow-lg rounded-t-3xl flex flex-col overflow-y-auto">
                <div className="flex flex-col gap-y-3 h-full items-start p-3">
                    {/* Top close button */}
                    <div className="w-full flex items-center justify-end">
                        <Button
                            className="bg-transparent hover:bg-transparent p-2"
                            onClick={onClose}
                            aria-label="Close"
                        >
                            <IoClose className="text-2xl text-black/60" />
                        </Button>
                    </div>

                    {/* Title */}
                    {title ? (
                        <div className="w-full px-1">
                            <h2 className="text-2xl font-bold capitalize">{title}</h2>
                        </div>
                    ) : undefined}

                    {/* Content (price, description, etc.) */}
                    <div className="flex flex-col flex-1 items-start w-full">
                        <div className="px-4 pt-4 pb-8 w-full">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BottomSheetV2
